[
  {
    "culture": "Kung"
  },
  {
    "culture": "Abua"
  },
  {
    "culture": "Adio"
  },
  {
    "culture": "African"
  },
  {
    "culture": "African Americans"
  },
  {
    "culture": "Africans"
  },
  {
    "culture": "Ainu"
  },
  {
    "culture": "Akan"
  },
  {
    "culture": "Akela"
  },
  {
    "culture": "Akoko"
  },
  {
    "culture": "Amhara"
  },
  {
    "culture": "Anga"
  },
  {
    "culture": "Aro"
  },
  {
    "culture": "Asante"
  },
  {
    "culture": "Ashanti"
  },
  {
    "culture": "Okpella"
  },
  {
    "culture": "Azande"
  },
  {
    "culture": "Babembe"
  },
  {
    "culture": "Baga"
  },
  {
    "culture": "Bakongo"
  },
  {
    "culture": "Bamana"
  },
  {
    "culture": "Bamum"
  },
  {
    "culture": "Bangala"
  },
  {
    "culture": "Bangwa"
  },
  {
    "culture": "Bantu"
  },
  {
    "culture": "Bantu-speaking peoples"
  },
  {
    "culture": "Bapoto"
  },
  {
    "culture": "Bapunu"
  },
  {
    "culture": "Baule"
  },
  {
    "culture": "Bawongo"
  },
  {
    "culture": "Bayanzi"
  },
  {
    "culture": "Bemba"
  },
  {
    "culture": "Bena"
  },
  {
    "culture": "Bena Biombo"
  },
  {
    "culture": "Blacks"
  },
  {
    "culture": "Boer"
  },
  {
    "culture": "Brong"
  },
  {
    "culture": "Budu"
  },
  {
    "culture": "Bushongo"
  },
  {
    "culture": "Byzantine"
  },
  {
    "culture": "Central African"
  },
  {
    "culture": "Cewa"
  },
  {
    "culture": "Chamba"
  },
  {
    "culture": "Chewa"
  },
  {
    "culture": "Christians"
  },
  {
    "culture": "Cikunda"
  },
  {
    "culture": "Cubans"
  },
  {
    "culture": "Dan"
  },
  {
    "culture": "Djerma"
  },
  {
    "culture": "Dogon"
  },
  {
    "culture": "Duala"
  },
  {
    "culture": "Ebira"
  },
  {
    "culture": "Edo"
  },
  {
    "culture": "Efik"
  },
  {
    "culture": "Egyptian"
  },
  {
    "culture": "Ekoi"
  },
  {
    "culture": "Ethiopians"
  },
  {
    "culture": "Ewe"
  },
  {
    "culture": "Fang"
  },
  {
    "culture": "Fante"
  },
  {
    "culture": "Fon"
  },
  {
    "culture": "Fulbe"
  },
  {
    "culture": "Gbari"
  },
  {
    "culture": "Ghanaian"
  },
  {
    "culture": "Griqua"
  },
  {
    "culture": "Gusii"
  },
  {
    "culture": "Hausa"
  },
  {
    "culture": "Ibibio"
  },
  {
    "culture": "Idoma"
  },
  {
    "culture": "Igala"
  },
  {
    "culture": "Igbo"
  },
  {
    "culture": "Ijo"
  },
  {
    "culture": "Ijaw"
  },
  {
    "culture": "Ivorian"
  },
  {
    "culture": "Jula"
  },
  {
    "culture": "Kaka"
  },
  {
    "culture": "Kalabari"
  },
  {
    "culture": "Kamba"
  },
  {
    "culture": "Khoekhoe"
  },
  {
    "culture": "Khoikhoi"
  },
  {
    "culture": "Kikuyu"
  },
  {
    "culture": "Kom"
  },
  {
    "culture": "Kongo"
  },
  {
    "culture": "Koniagui"
  },
  {
    "culture": "Konso"
  },
  {
    "culture": "Kota"
  },
  {
    "culture": "Kuba"
  },
  {
    "culture": "Lega"
  },
  {
    "culture": "Lobi"
  },
  {
    "culture": "Lozi"
  },
  {
    "culture": "Luba"
  },
  {
    "culture": "Lulua"
  },
  {
    "culture": "Maabube"
  },
  {
    "culture": "Maasai"
  },
  {
    "culture": "Magwangwara"
  },
  {
    "culture": "Makonde"
  },
  {
    "culture": "Malian"
  },
  {
    "culture": "Mambwe"
  },
  {
    "culture": "Mande"
  },
  {
    "culture": "Mangbetu"
  },
  {
    "culture": "Maroon"
  },
  {
    "culture": "Mbole"
  },
  {
    "culture": "Mbosi"
  },
  {
    "culture": "Mekan"
  },
  {
    "culture": "Mende"
  },
  {
    "culture": "Merina"
  },
  {
    "culture": "Merina (Malagasy people)"
  },
  {
    "culture": "Meroitic"
  },
  {
    "culture": "Mossi"
  },
  {
    "culture": "Mozambiquean"
  },
  {
    "culture": "Mpondomise"
  },
  {
    "culture": "Mumuye"
  },
  {
    "culture": "Mundang"
  },
  {
    "culture": "Muslims"
  },
  {
    "culture": "Nalu"
  },
  {
    "culture": "Ndebele"
  },
  {
    "culture": "Nigerian"
  },
  {
    "culture": "North African"
  },
  {
    "culture": "Nupe"
  },
  {
    "culture": "Nyanja"
  },
  {
    "culture": "Okpella"
  },
  {
    "culture": "Ovimbundu"
  },
  {
    "culture": "Papel"
  },
  {
    "culture": "Pende"
  },
  {
    "culture": "Pondo"
  },
  {
    "culture": "Popo"
  },
  {
    "culture": "Prehistoric peoples"
  },
  {
    "culture": "San"
  },
  {
    "culture": "Senufo"
  },
  {
    "culture": "Sherbro"
  },
  {
    "culture": "Shi"
  },
  {
    "culture": "Shilluk"
  },
  {
    "culture": "Shona"
  },
  {
    "culture": "Siculo-Punic"
  },
  {
    "culture": "Sierra Leoneans"
  },
  {
    "culture": "Somali"
  },
  {
    "culture": "Somalis"
  },
  {
    "culture": "Songhai"
  },
  {
    "culture": "Songye"
  },
  {
    "culture": "Soninke"
  },
  {
    "culture": "Sotho"
  },
  {
    "culture": "South African"
  },
  {
    "culture": "South Africans"
  },
  {
    "culture": "Sura"
  },
  {
    "culture": "Swahili"
  },
  {
    "culture": "Swahili-speaking peoples"
  },
  {
    "culture": "Swazi"
  },
  {
    "culture": "Tanzanians"
  },
  {
    "culture": "Temne"
  },
  {
    "culture": "Tiv"
  },
  {
    "culture": "Tsonga"
  },
  {
    "culture": "Tswana"
  },
  {
    "culture": "Tukulor"
  },
  {
    "culture": "Twi"
  },
  {
    "culture": "Ugandans"
  },
  {
    "culture": "Unidentified culture"
  },
  {
    "culture": "Urhobo"
  },
  {
    "culture": "Venda"
  },
  {
    "culture": "Waja"
  },
  {
    "culture": "West African"
  },
  {
    "culture": "West Africans"
  },
  {
    "culture": "Wolof"
  },
  {
    "culture": "Xhosa"
  },
  {
    "culture": "Yaka"
  },
  {
    "culture": "Yao (Africa)"
  },
  {
    "culture": "Yoruba"
  },
  {
    "culture": "Zaghawa"
  },
  {
    "culture": "Zulu"
  },
  {
    "culture": "Zulu (?)"
  }
]
